import { render, staticRenderFns } from "./AnswerOptionCreate.vue?vue&type=template&id=76aaec14&"
import script from "./AnswerOptionCreate.vue?vue&type=script&lang=js&"
export * from "./AnswerOptionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports